<template>
  <v-dialog v-model="active" persistent width="500">
    <v-card>
      <v-card-title class="headline" primary-title>{{
        saveProjectSettings ? "Endre kartinnstillinger" : "Lagre kart"
      }}</v-card-title>

      <v-card-text v-if="saveInProgress">
        <div class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </v-card-text>

      <v-card-text v-if="!saveInProgress">
        <div v-if="!saveProjectSettings">
          <p class="caption">
            Når du lagrer kartet lagres en kopi av visningen (dvs. kartlag,
            filter, utsnitt, bakgrunnskart) på NVE sine servere. Det lagres også
            en referanse til kartet i nettleseren din, slik at du kan åpne
            kartet igjen ved å velge "åpne kart" i menyen.
          </p>
          <p class="caption">
            Vi anbefaler at du tar vare på lenken til kartet ditt som du finner
            ved å velge "Del kartet" i menyen. Da kan du åpne kartet fra en
            annen datamaskin, og finne kartet selv om
            nettleserhistorikken/cachen blir slettet.
          </p>
          <p class="caption">
            <strong>Merknad:</strong> Lagrefunksjonen må ikke brukes til å lagre
            sensitiv informasjon. Hvis du legger inn viktig informasjon i kartet
            så bør du ha en kopi av denne informasjon et annet sted, i tilfelle
            det gjøres endringer i denne løsningen.
          </p>
        </div>
        <v-text-field
          :label="
            saveProjectSettings
              ? 'Endre navnet på kartet'
              : 'Gi kartet et navn (obligatorisk)'
          "
          v-model="title"
          box
          full-width
          maxlength="100"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat :disabled="!title" @click="saveProject"
          >Lagre</v-btn
        >
        <v-btn flat @click="emitDialogClosedEvent">Avbryt</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";

export default {
  name: "SaveProjectDialog",
  computed: {
    ...mapState(["currentlyOpenedProject", "userIsLoggedIn"])
  },
  mixins: [MappingMixin],
  data: () => ({
    dialog: false,
    title: null,
    projectIsPublic: false,
    projectEditRole: "eier",
    saveInProgress: false,
    projectEditRoles: [
      {
        text: "Kun jeg skal kunne redigere kartet",
        value: "eier"
      },
      {
        text: "Alle skal kunne redigere kartet",
        value: "alle"
      }
    ]
  }),
  props: {
    active: Boolean,
    saveProjectSettings: Boolean
  },
  watch: {
    active: function(newVal) {
      if (newVal == true) {
        this.saveInProgress = false;
      }
    }
  },
  methods: {
    ...mapActions(["setSnack", "clearCurrentlyOpenedProject"]),
    emitDialogClosedEvent() {
      this.title = null;
      this.$emit("close-dialog");
    },
    saveProject() {
      this.saveInProgress = true;
      if (!this.saveProjectSettings) {
        this.clearCurrentlyOpenedProject();
      }

      this.saveMap({
        attributes: {
          tittel: this.title,
          Offentlig: this.projectIsPublic ? 1 : 0,
          redigering: this.projectEditRole
        }
      })
        .then(() => {
          this.emitDialogClosedEvent();
          this.setSnack("Kart lagret");
        })
        .catch(error => {
          console.error(error);
          this.setSnack("Lagring ikke gjennomført. Prøv igjen om litt.");
        });
    }
  },
  mounted() {
    if (!this.userIsLoggedIn) {
      this.projectIsPublic = true;
    }
    if (this.currentlyOpenedProject !== null) {
      this.projectEditRole =
        this.currentlyOpenedProject.attributes.redigering == null
          ? "eier"
          : this.currentlyOpenedProject.attributes.redigering;
      this.title = this.currentlyOpenedProject.attributes.tittel;

      this.projectIsPublic =
        this.currentlyOpenedProject.attributes.Offentlig == 1;
    }
  }
};
</script>

<style scoped></style>
